import { FieldViewModel, defineDirective, ExplorerContext, getSingleFieldRootNodes, IDatalayersMap, LayerBrowserContext, LayerViewModel, LmNode, map, runOnLayersLoaded } from "../../omnia"
import { canEditLayer } from "../../utils"
import { expandPath, findMultiplePaths } from "../explorer"
import { mainCssClass } from "../menu"
import { ContextMenuArguments } from "../types"

export class ContextMenuCtrl implements LayerBrowserContext {

    static create() {
        return defineDirective(ContextMenuCtrl, "app/datalayers/menu/cxm/cxm.html", {
            args: "="
        })
    }

    args: ContextMenuArguments

    tooltip: map.IMapTooltip
    ctxt: ExplorerContext
    map: IDatalayersMap

    rootNodes: LmNode[]

    field: FieldViewModel
    layer: LayerViewModel

    fieldDescription: string

    layers: LayerViewModel[]

    topmost: { datalayerId: number }


    $onInit() {

        const args = this.args
        if (!args) return

        const ctxt = this.ctxt = args.context
        this.tooltip = args.tooltip

        const f = this.field = args.field

        this.fieldDescription = f.fieldVm.getDescription(true)

        this.rootNodes = getSingleFieldRootNodes(ctxt.getNodesContext(), f)

        const visible = findMultiplePaths(this.rootNodes, n => n.getChildren(true).some(l => l.layer && l.layer.visible), n => n.getChildren(true))
        visible.forEach(expandPath)

        this.refreshLoadedLayers()

    }

    private refreshLoadedLayers() {

        const ctxt = this.ctxt
        const map = this.map = ctxt.map
        const f = this.field

        const layers = ctxt.getLayers(l => (l.zonesLoaded || l.visible) && (l.fieldId == f.fieldId))

        this.layers = map.sortByStackOrder(layers, l => l.mapLayer)

        this.updateTopmost()

    }

    viewExtent() {
        this.map.viewExtentForDataItem(this.field)
    }

    canCreateLayer() {
        const { ctxt } = this
        return !(ctxt.readOnlySession || ctxt.readOnlyContext)
    }

    createLayer() {
        this.ctxt.editLayer({ field: this.field }, true)
    }

    showInExplorer() {
        const layer = this.layer ? this.layer.mapLayer : undefined
        this.ctxt.locateInExplorer(layer || this.field)
    }

    get mainCssClass() {
        return mainCssClass
    }

    get activeLayer() {
        return this.ctxt ? this.ctxt.activeLayer : undefined
    }

    toggleLayer(l: LayerViewModel) {

        const { ctxt, tooltip } = this

        tooltip.canClose = () => false

        const fieldId = l.fieldId
        const v = (!l.visible) || (ctxt.activeLayer != l)

        l.visible = v

        const callback = () => {

            const active = v ? l.mapLayer : this.map.getTopmostLayer(l => (l.fieldId == fieldId) && l.visible && !!l.zones)

            if (active) {
                ctxt.locateInExplorer(active)
            }
            else {
                ctxt.activeLayer = null
            }

            ctxt.onLayerVisibilityChanged([l], v)

            tooltip.canClose = undefined

            this.refreshLoadedLayers()

        }

        if (v) {
            runOnLayersLoaded([l], callback)
        }
        else {
            callback()
        }
    }

    isTopmost(l: LayerViewModel) {
        return l && this.topmost && (l.datalayerId == this.topmost.datalayerId)
    }

    updateTopmost() {
        const fieldId = this.field.fieldId
        this.topmost = this.map.getTopmostLayer(l => l.fieldId == fieldId)
    }

    canEditLayer(l: LayerViewModel) {
        return l && this.isTopmost(l) && canEditLayer(l)
    }

    editLayer(l: LayerViewModel) {
        this.ctxt.editLayer({ field: l.field, layer: l }, false)
    }

    compareLayers() {
        const { field, ctxt } = this
        if (field) {
            ctxt.compareFieldLayers(field.fieldId)
        }
    }

}
